(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8455],{

/***/ 45370:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us",
      function () {
        return __webpack_require__(22793);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 22793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var _components_form_fields__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68143);
/* harmony import */ var _components_form_layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76817);
/* harmony import */ var _components_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20388);
/* harmony import */ var _contexts_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28798);
/* harmony import */ var _hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(97859);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47392);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45911);
/* harmony import */ var _utils_helpers_tracking__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68379);
/* harmony import */ var _utils_schemas__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73705);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46392);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(82684);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(75367);
/* harmony import */ var upper_case_first__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(85298);














const ContactUs = (param)=>{
    let { content , tracking , brand  } = param;
    var ref, ref1;
    const query = (0,_contexts_index__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .aM)();
    const [submitResponse, setSubmitResponse] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)("");
    const [user, setUser] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(false);
    const [formStep, setFormStep] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(1);
    const [showDealer, setShowDealer] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(false);
    const typeOfEnquiry = {
        "general-enquiries": _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .TYPE_OF_ENQUIRIES_GENERAL */ .J_,
        "roadside-assistance": _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .TYPE_OF_ENQUIRIES_ROADSIDE */ .pk,
        multimedia: _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .TYPE_OF_ENQUIRIES_MULTIMEDIA */ .fV,
        "financial-services": _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .TYPE_OF_ENQUIRIES_FINANCE */ .cU
    };
    const step = (newFormStep, userState)=>{
        setUser(userState);
        setFormStep(newFormStep);
    };
    const initialValues = {
        form_name: "",
        title: "",
        first_name: "",
        last_name: "",
        email: "",
        date_of_birth: "",
        day: "",
        month: "",
        year: "",
        agreement_or_reg_num: "",
        type_of_enquiry: "",
        house_number: "",
        address_line1: "",
        address_line2: "",
        town: "",
        county: "",
        postcode: "",
        telephone_number: "",
        mobile_number: "",
        additional_info: "",
        company_name: "",
        enquiry_description: "",
        urn: "",
        dealer: "",
        dealer_name: "",
        dealer_id: "",
        membership_number: "",
        reg_num: "",
        fleet_type: "",
        is_lexus: brand === "lexus",
        toyota_owner: false
    };
    const methods = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_11__/* .useForm */ .cI)({
        resolver: (0,_hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_12__/* .yupResolver */ .X)(_utils_schemas__WEBPACK_IMPORTED_MODULE_8__/* .ContactUsSchema */ .CV),
        defaultValues: initialValues,
        mode: "onTouched"
    });
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{
        if (query === null || query === void 0 ? void 0 : query.type) {
            const formName = methods.getValues("form_name");
            if (formName && typeOfEnquiry[formName]) {
                const result = Object.values(typeOfEnquiry[formName]).find((item)=>{
                    var ref, ref1;
                    return (item === null || item === void 0 ? void 0 : (ref = item.label) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === (query === null || query === void 0 ? void 0 : (ref1 = query.type) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase());
                });
                methods.setValue("enquiry_description", result === null || result === void 0 ? void 0 : result.label);
                methods.setValue("type_of_enquiry", result === null || result === void 0 ? void 0 : result.value);
            }
        }
    }, [
        methods,
        query,
        typeOfEnquiry
    ]);
    const CardStep = ()=>methods.getValues("form_name") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "relative ".concat(brand === "lexus" ? " uppercase" : ""),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "md:flex flex-col",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: "flex hover:underline",
                        onClick: ()=>{
                            step(1, true);
                            methods.reset(initialValues);
                            setSubmitResponse("");
                            setShowDealer(false);
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col items-baseline md:flex-row md:space-x-2 md:justify-between",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "font-medium ".concat(brand === "lexus" ? " uppercase" : ""),
                                    children: "1. Type"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-tiny",
                                    children: "Change"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "md:flex text-tiny hidden mt-1",
                        children: (0,upper_case_first__WEBPACK_IMPORTED_MODULE_13__/* .upperCaseFirst */ .l)(content.forms[methods.getValues("form_name")].name).replace(/-/g, " ")
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "flex flex-row",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "".concat(formStep === 2 ? "font-medium" : "font-semibold"),
                children: "1. Type"
            })
        });
    const DetailsStep = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "relative ".concat(brand === "lexus" ? " uppercase" : ""),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "md:flex items-center"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex flex-row",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "".concat(formStep === 1 ? "font-medium" : "font-semibold"),
                        children: "2. Details"
                    })
                })
            ]
        });
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{
        if ((query === null || query === void 0 ? void 0 : query.form) || (query === null || query === void 0 ? void 0 : query.method)) {
            const isActive = content.forms[query.form || query.method].active;
            if (isActive) {
                methods.setValue("form_name", query.form || query.method);
            }
            if (query === null || query === void 0 ? void 0 : query.type) {
                const isTypeAvailable = typeOfEnquiry[query.form || query.method].find((o)=>o.value === query.type);
                if (isTypeAvailable) {
                    methods.setValue("type_of_enquiry", isTypeAvailable.value);
                    methods.setValue("enquiry_description", isTypeAvailable.label);
                    setShowDealer(isTypeAvailable.value === "general_enquiry:2");
                    if (isTypeAvailable.value === "general_enquiry:2") {
                        methods.resetField("dealer");
                    }
                }
            }
        }
    }, [
        query
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{
        const type = methods.getValues("form_name");
        if (type) {
            step(2, user);
            if (brand === "lexus" && type === "general-enquiries") {
                methods.setValue("type_of_enquiry", "general");
                methods.setValue("enquiry_description", "Help with My Lexus");
            }
            if (brand === "lexus" && type === "multimedia") {
                methods.setValue("type_of_enquiry", "mm_nav");
                methods.setValue("enquiry_description", "Help with My Lexus (Nav)");
            }
        }
    }, [
        methods.watch("form_name")
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{
        const dealer = methods.getValues("dealer");
        if (dealer) {
            var ref, ref1;
            methods.setValue("dealer_id", (ref = dealer.split("::")[1]) === null || ref === void 0 ? void 0 : ref.trim());
            methods.setValue("dealer_name", (ref1 = dealer.split("::")[0]) === null || ref1 === void 0 ? void 0 : ref1.trim());
        }
    }, [
        methods.watch("dealer")
    ]);
    const onSubmit = async (data)=>{
        setSubmitResponse("");
        const parsedData = {
            ...data
        };
        switch(parsedData.form_name){
            case "financial-services":
                parsedData.form_name = "tfs_contact_form";
                break;
            case "fleet-services":
                parsedData.form_name = "fleet_contact_form";
                parsedData.type_of_enquiry = "Other";
                break;
            default:
                parsedData.form_name = "contact_form";
                break;
        }
        if (query === null || query === void 0 ? void 0 : query.path) {
            parsedData.additional_info = "".concat(parsedData === null || parsedData === void 0 ? void 0 : parsedData.additional_info, " | User entered via the Multimedia tool path: ").concat(query === null || query === void 0 ? void 0 : query.path);
        }
        if (parsedData.day) {
            parsedData.date_of_birth = "".concat(data.day, "/").concat(data.month, "/").concat(data.year);
        }
        // eslint-disable-next-line prefer-destructuring
        parsedData.type_of_enquiry = parsedData.type_of_enquiry.split(":")[0];
        await (0,axios__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)({
            method: "post",
            url: "".concat("https://api.toyota.co.uk/forms/api", "/contact-us-submissions"),
            headers: {
                "Content-Type": "application/json"
            },
            data: parsedData
        }).then(()=>{
            (0,_utils_helpers_tracking__WEBPACK_IMPORTED_MODULE_7__/* .formEvent */ .Be)({
                conversion: 1,
                name: tracking.form,
                step: "form-submit",
                variant: data.form_name,
                page: tracking.page
            });
            (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_6__/* .closeOverlay */ .Km)(content.forms[data.form_name].confirmation.title, content.forms[data.form_name].confirmation.copy, setSubmitResponse, false);
        }).catch(()=>{
            (0,_utils_helpers_tracking__WEBPACK_IMPORTED_MODULE_7__/* .formEvent */ .Be)({
                conversion: 0,
                name: tracking.form,
                step: "form-error",
                variant: data.form_name,
                page: tracking.page
            });
            setSubmitResponse(_utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .ERROR_MESSAGE */ .c9);
            throw new Error(_utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .ERROR_MESSAGE */ .c9);
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui__WEBPACK_IMPORTED_MODULE_3__/* .Nav */ .JL, {
                title: content.title,
                logoType: content === null || content === void 0 ? void 0 : content.logotype,
                customLogo: content === null || content === void 0 ? void 0 : content.customlogo,
                steps: [
                    CardStep(),
                    DetailsStep()
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_layout__WEBPACK_IMPORTED_MODULE_2__/* .FormWrapper */ .n, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_hook_form__WEBPACK_IMPORTED_MODULE_11__/* .FormProvider */ .RV, {
                    ...methods,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_layout__WEBPACK_IMPORTED_MODULE_2__/* .FormStep */ .p, {
                            subtitle: content.subtitle,
                            step: formStep,
                            active: formStep === 1,
                            user: user,
                            tracking: {
                                conversion: 0,
                                name: tracking.form,
                                step: "select-type",
                                variant: tracking.variant,
                                page: tracking.page
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .ContactGrid */ .HN, {
                                forms: content.forms,
                                setUser: setUser
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_layout__WEBPACK_IMPORTED_MODULE_2__/* .FormStep */ .p, {
                            title: (ref = content === null || content === void 0 ? void 0 : content.forms[methods.getValues("form_name")]) === null || ref === void 0 ? void 0 : ref.name,
                            subtitle: (ref1 = content === null || content === void 0 ? void 0 : content.forms[methods.getValues("form_name")]) === null || ref1 === void 0 ? void 0 : ref1.details.subtitle,
                            step: formStep,
                            active: formStep === 2,
                            user: user,
                            tracking: {
                                conversion: 0,
                                name: tracking.form,
                                step: "contact-details",
                                variant: methods.getValues("form_name") || "",
                                page: tracking.page
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                                onSubmit: methods.handleSubmit(onSubmit),
                                children: [
                                    methods.getValues("form_name") === "general-enquiries" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .AuthFill */ .Pl, {}),
                                            brand === "toyota" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .DropDown */ .vb, {
                                                name: "type_of_enquiry",
                                                label: "Type of Enquiry",
                                                options: _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .TYPE_OF_ENQUIRIES_GENERAL */ .J_,
                                                onChange: (e)=>{
                                                    methods.setValue("enquiry_description", _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .TYPE_OF_ENQUIRIES_GENERAL */ .J_[e.target.selectedIndex - 1].label);
                                                    methods.setValue("type_of_enquiry", _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .TYPE_OF_ENQUIRIES_GENERAL */ .J_[e.target.selectedIndex - 1].value);
                                                    setShowDealer(e.target.value === "general_enquiry:2");
                                                    if (e.target.value === "general_enquiry:2") {
                                                        methods.resetField("dealer");
                                                    }
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Title */ .Dx, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .FirstName */ .SW, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .LastName */ .uQ, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Email */ .GT, {}),
                                            brand === "lexus" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Tel */ .ki, {
                                                optional: true
                                            }),
                                            showDealer && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Dealers */ .fD, {
                                                label: "Dealer",
                                                optional: true
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .VehicleRegNo */ .Mb, {
                                                optional: true
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Comments */ .HW, {
                                                optional: true,
                                                className: "resize-y w-full",
                                                name: "additional_info",
                                                label: "Your Question",
                                                characterLimit: 2000
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .MarketingTerms */ .Jy, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                                submitResponse: submitResponse,
                                                children: content.forms["general-enquiries"].details.submit
                                            })
                                        ]
                                    }),
                                    methods.getValues("form_name") === "roadside-assistance" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .AuthFill */ .Pl, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .DropDown */ .vb, {
                                                name: "type_of_enquiry",
                                                label: "Type of Enquiry",
                                                options: _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .TYPE_OF_ENQUIRIES_ROADSIDE */ .pk,
                                                onChange: (e)=>{
                                                    methods.setValue("enquiry_description", _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .TYPE_OF_ENQUIRIES_ROADSIDE */ .pk[e.target.selectedIndex - 1].label);
                                                    methods.setValue("type_of_enquiry", _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .TYPE_OF_ENQUIRIES_ROADSIDE */ .pk[e.target.selectedIndex - 1].value);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Title */ .Dx, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .FirstName */ .SW, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .LastName */ .uQ, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Email */ .GT, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .MembershipNo */ .q1, {
                                                optional: true
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .VehicleRegNo */ .Mb, {
                                                optional: true
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Comments */ .HW, {
                                                optional: true,
                                                name: "additional_info",
                                                label: "Your Question"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .MarketingTerms */ .Jy, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                                submitResponse: submitResponse,
                                                children: content.forms["roadside-assistance"].details.submit
                                            })
                                        ]
                                    }),
                                    methods.getValues("form_name") === "multimedia" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .AuthFill */ .Pl, {}),
                                            brand === "toyota" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .DropDown */ .vb, {
                                                name: "type_of_enquiry",
                                                label: "Type of Enquiry",
                                                options: _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .TYPE_OF_ENQUIRIES_MULTIMEDIA */ .fV,
                                                onChange: (e)=>{
                                                    methods.setValue("enquiry_description", _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .TYPE_OF_ENQUIRIES_MULTIMEDIA */ .fV[e.target.selectedIndex - 1].label);
                                                    methods.setValue("type_of_enquiry", _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .TYPE_OF_ENQUIRIES_MULTIMEDIA */ .fV[e.target.selectedIndex - 1].value);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Title */ .Dx, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .FirstName */ .SW, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .LastName */ .uQ, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Email */ .GT, {}),
                                            brand === "lexus" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Tel */ .ki, {
                                                optional: true
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .VehicleRegNo */ .Mb, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Comments */ .HW, {
                                                optional: true,
                                                className: "resize-y w-full",
                                                name: "additional_info",
                                                label: "Your Question",
                                                characterLimit: 2000
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .MarketingTerms */ .Jy, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                                submitResponse: submitResponse,
                                                children: content.forms.multimedia.details.submit
                                            })
                                        ]
                                    }),
                                    methods.getValues("form_name") === "financial-services" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .AuthFill */ .Pl, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .DropDown */ .vb, {
                                                name: "type_of_enquiry",
                                                label: "Type of Enquiry",
                                                options: _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .TYPE_OF_ENQUIRIES_FINANCE */ .cU,
                                                onChange: (e)=>{
                                                    methods.setValue("enquiry_description", _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .TYPE_OF_ENQUIRIES_FINANCE */ .cU[e.target.selectedIndex - 1].label);
                                                    methods.setValue("type_of_enquiry", _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .TYPE_OF_ENQUIRIES_FINANCE */ .cU[e.target.selectedIndex - 1].value);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .AgreementNo */ .Se, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Title */ .Dx, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .FirstName */ .SW, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .LastName */ .uQ, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Email */ .GT, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .DateOfBirth */ .nH, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Tel */ .ki, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .AddressLookup */ .Ij, {
                                                methods: methods
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Comments */ .HW, {
                                                optional: true,
                                                name: "additional_info",
                                                label: "Additional Information"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .FinancialTerms */ .QL, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                                submitResponse: submitResponse,
                                                children: content.forms["financial-services"].details.submit
                                            })
                                        ]
                                    }),
                                    methods.getValues("form_name") === "fleet-services" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .AuthFill */ .Pl, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Title */ .Dx, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .FirstName */ .SW, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .LastName */ .uQ, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .CompanyName */ .zo, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Email */ .GT, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Tel */ .ki, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .AddressLookup */ .Ij, {
                                                methods: methods
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Comments */ .HW, {
                                                optional: true,
                                                name: "additional_info",
                                                label: "Reason for contact"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .MarketingTerms */ .Jy, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                                submitResponse: submitResponse,
                                                children: content.forms["fleet-services"].details.submit
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
ContactUs.whyDidYouRender = true;
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ContactUs);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7409,1850,9595,9516,388,4817,9774,2888,179], function() { return __webpack_exec__(45370); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);